export enum ProjectEvents {
    AssessSchedModelDidUpdate = 'Project.AssessmentScheduler.FormModelDidUpdate',
    AssessRecordMainModelDidUpdate = 'Project.AssessmentRecorder.Main.FormModelDidUpdate',
    AssessRecordDoorModelDidUpdate = 'Project.AssessmentRecorder.Door.FormModelDidUpdate',
    AssessRecordLaborModelDidUpdate = 'Project.AssessmentRecorder.Labor.FormModelDidUpdate',
    AssessRecordMatModelDidUpdate = 'Project.AssessmentRecorder.Material.FormModelDidUpdate',
    AssessmentEditorPanel_Launch = 'Project.AssessmentEditorPanel.Launch',
    AssessmentEditorPanelFreeToClose = 'Project.AssessmentEditorPanel.FreeToClose',
    LaborEditorPanel_Launch = 'Project.LaborEditorPanel.Launch',
    LaborEditorPanelFreeToClose = 'Project.LaborEditorPanel.FreeToClose',
    MaterialEditorPanel_Launch = 'Project.MaterialEditorPanel.Launch',
    CancellationModelDidUpdate = 'Project.Cancellation.FormModelDidUpdate',
    ProjectCancellationPanel_Launch = 'Project.ProjectCancellationPanel.Launch',
    CustomerModelDidUpdate = 'Project.Customer.FormModelDidUpdate',
    CustomerPanel_Launch = 'Project.CustomerPanel.Launch',
    IncentiveEditorDidUpdate = 'Project.IncentiveEditor.FormModelDidUpdate',
}